/**
 * Extracts the underlying event name from an oriented relationship label.
 * @param relationshipName - Reviewed relationship display name.
 * @returns Event-level label shared by both executable orientations.
 */
export function relationshipEventName(relationshipName: string): string {
  return relationshipName.split(' — ')[0] ?? relationshipName;
}
